import { render, staticRenderFns } from "./DeliveryPreference.vue?vue&type=template&id=97ce9922"
import script from "./DeliveryPreference.vue?vue&type=script&lang=js"
export * from "./DeliveryPreference.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPreference.vue?vue&type=style&index=0&id=97ce9922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports